/**
 * App-wide Jotai store singleton.
 *
 * Using a custom store (not the default one) requires all cross-component
 * utilities — like query invalidation helpers — to import this exact
 * instance so that reads/writes land on the same atom instance tree.
 */
import { createStore } from 'jotai'

export const appStore = createStore()
